module.exports = {
	"name": "common",
	"version": "1.0.509",
	"private": true,
	"description": "",
	"es6": true,
	"main": "./application.js",
	"scripts": {
		"test": "echo \"Error: no test specified\" && exit 1"
	},
	"author": "",
	"license": "ISC"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/package.json
 ** module id = 486
 ** module chunks = 0
 **/